import React from 'react';
import GsecLetterPrintButton from './GsecLetterPrintButton';
import { isBuySellBuyback } from '../utils/buybackDeal';

const letterBtnStyle = {
  padding: '6px 14px',
  background: '#17a2b8',
  color: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: '0.85em'
};

/** Leg 1 / Leg 2 settlement letters for Buy/Sell buybacks only (Approved). */
export default function BuySellLetterButtons({ tx }) {
  if (!isBuySellBuyback(tx) || tx.deal_status !== 'Approved') return null;
  return (
    <>
      {tx.leg1_letter_gsec_id && (
        <GsecLetterPrintButton
          transaction={{ id: tx.leg1_letter_gsec_id, status: 'final_approved' }}
          label="Leg 1 Letter"
          style={letterBtnStyle}
          title="Print leg 1 (Buy) settlement instruction letter"
        />
      )}
      {tx.leg2_letter_gsec_id && (
        <GsecLetterPrintButton
          transaction={{ id: tx.leg2_letter_gsec_id, status: 'final_approved' }}
          label="Leg 2 Letter"
          style={letterBtnStyle}
          title="Print leg 2 (Sell) settlement instruction letter"
        />
      )}
    </>
  );
}
